import React, { useState, useEffect } from 'react';

function Notification({ type, message, hideNotification = null }) {
  const [notification, setNotification] = useState(type);

  useEffect(() => {
    setNotification(type);
    setTimeout(() => {
      setNotification(null);
      if (hideNotification) hideNotification();
    }, 4000);
  }, [type, message]);

  const getBgColor = React.useMemo(() => {
    switch (type) {
      case 'success':
        return 'bg-green-600';
      case 'error':
        return 'bg-red-600';
    }
  }, [type]);

  const getNewBgColor = React.useMemo(() => {
    switch (type) {
      case 'success':
        return 'bg-green-500';
      case 'error':
        return 'bg-red-500';
    }
  }, [type]);

  return (
    <div>
      {notification ? (
        <div
          className={`p-2 absolute z-50 bottom-5 left-5 items-center ${getBgColor} text-white leading-none lg:rounded-full flex lg:inline-flex`}
          role="alert"
        >
          <span className={`flex rounded-full ${getNewBgColor} uppercase px-2 py-1 text-xs font-bold mr-4`}>New</span>
          <span className="font-semibold mr-3 text-left flex-auto">{message}</span>
        </div>
      ) : null}
    </div>
  );
}
export default Notification;
